import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'finTimestamp',
  pure: false,
  standalone: false,
})
export class TimestampPipe implements PipeTransform {
  transform(timestamp: string | number | Date): string {
    return formatDate(timestamp, 'dd.MM.yyyy', 'en-FI');
  }
}
